import React from 'react'
import PropTypes from 'prop-types'

export const Menu = (props) => {
  const {
    classes,
    children,
    className,
    style,
    position = 'left' | 'right' | 'up' | 'down',
    ...rest
  } = props
  return (
    <div position={position} className={className} {...rest} style={style}>
      {children}
    </div>
  )
}

Menu.propTypes = {
  children: PropTypes.node,
  position: PropTypes.oneOf(['left', 'right', 'up', 'down']),
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
}

Menu.defaultProps = {
  position: 'left'
}

Menu.displayName = 't'

export default Menu
